export default {
    items: [{
            name: 'Dashboard',
            url: '/case/dashboard',
            icon: 'cui-dashboard',
            badge: {
                variant: 'primary',
            }
        },
        {
            name: 'Case Listing',
            url: '',
            icon: 'icon-layers',
            badge: {
                variant: 'primary',
            },
            children: [
                {
                    name: 'All Cases',
                    url: '/case/list',
                    icon: 'icon-arrow-right',
                },
                // {
                //     name: 'Old Cases',
                //     url: '/case/old-case-list',
                //     icon: 'icon-arrow-right',
                // },
            ]
        },
        {
            name: 'Email Listing',
            url: '',
            icon: 'icon-layers',
            badge: {
                variant: 'primary',
            },
            children: [
                {
                    name: 'All Emails',
                    url: '/case/emails/inbox',
                    icon: 'icon-arrow-right',
                },
                
            ]
        },

        {
            name: 'Accounts',
            url: '',
            icon: 'icon-people',
            badge: {
                variant: 'primary',
            },
            children: [{
                    name: 'Companies',
                    url: '/case/companies',
                    icon: 'icon-arrow-right',
                },
                {
                    name: 'Users',
                    url: '/case/users',
                    icon: 'icon-arrow-right',
                },
                {
                    name: 'Roles and Authorisation',
                    url: '/case/roles',
                    icon: 'icon-arrow-right',
                },
                {
                    name: 'Audit Trails',
                    url: '/case/audit-trail',
                    icon: 'icon-arrow-right',
                },
                {
                    name: 'Import Logs',
                    url: '/case/import-logs',
                    icon: 'icon-arrow-right',
                },
                {
                    name: 'User Duty',
                    url: '/case/user-duty',
                    icon: 'icon-arrow-right',
                },
            ]
        },
        {
            name: 'Notifications',
            url: '/case/config-notification',
            icon: 'icon-star',
        },
        {
            name: 'Settings',
            url: '',
            icon: 'icon-equalizer',
            badge: {
                variant: 'primary',
            },
            children: [{
                name: 'Case SLA',
                url: '/case/sla',
                icon: 'icon-arrow-right',
            },
            {
                name: 'NLT Escalation',
                url: '/case/nlt-escalation',
                icon: 'icon-arrow-right',
            },
            {
                name: 'NLT Covered Site',
                url: '/case/nlt-covered-site',
                icon: 'icon-arrow-right',
            },
            {
                name: 'NLT Property',
                url: '/case/nlt-property',
                icon: 'icon-arrow-right',
            },
            {
                name: 'NLT Address Book',
                url: '/case/nlt-address-book',
                icon: 'icon-arrow-right',
            },
            {
                name: 'NLT Report Listing',
                url: '/case/nlt-report-list',
                icon: 'icon-arrow-right',
            },
            {
                name: 'NLT Mailing List',
                url: '/case/nlt-mailing-list-management',
                icon: 'icon-arrow-right',
            },
            ]
        },
    ]
}
